import {Slick} from './theme/Slick';
import {Header} from './theme/Header';
import {Tab} from "./bootstrap/tab";
import {NewsFilter} from "./theme/NewsFillters";
import {Modal} from "./bootstrap/modal";
import {ValidatePassword} from "./theme/ValidatePassword";
import {LazyLoad} from "./bootstrap/LazyLoad";

jQuery(function ($) {
    //stickyHeader();
    active_hamburger();
    scroll_to_top();
    generateSvg();
    switchContent('.switchContent');
    new Slick().activate();
    new Header().activate();
    new Tab('price', 'squash');
    new Tab('tabs');
    new Modal();
    new NewsFilter();
    new ValidatePassword();
    new LazyLoad('.frontTeam');
    new LazyLoad('.frontPartners');
    new LazyLoad('.frontEvents');
    new LazyLoad('.spa');
    footerMenu();
    popover();

    if (document.body.offsetWidth < 1324) {
    } else {
        var wow = new WOW(
            {
                boxClass: 'wow',      // animated element css class (default is wow)
                animateClass: 'animated', // animation css class (default is animated)
                offset: 100,          // distance to the element when triggering the animation (default is 0)
                mobile: true,       // trigger animations on mobile devices (default is true)
                live: true,       // act on asynchronously loaded content (default is true)
                callback: function (box) {
                    // the callback is fired every time an animation is started
                    // the argument that is passed in is the DOM node being animated
                },
                scrollContainer: null // optional scroll container selector, otherwise use window
            }
        );
        wow.init();
    }

    if (!document.body.classList.contains('page-template-Booking')) {
        $('input[type="checkbox"]').after('<div class="checkmark"></div>');

        const checkmarks = document.querySelectorAll('.checkmark');
        checkmarks.forEach((checkmark) => {
            checkmark.addEventListener('click', () => {
                let checked = checkmark.previousElementSibling.checked;

                checkmark.previousElementSibling.checked = !checked;
            })
        });
    }

    function footerMenu() {
        let element = $('.footerMenu');

        element.click(() => {

            let width = $(document).width();
            if (width < 569) {
                element.find('.footerMenu__ul').slideToggle();
            }
        });
    }

    function popover() {
        let elements = document.querySelectorAll('[data-toggle="popover"]');

        elements.forEach((element) => {

            element.addEventListener('click', () => {
                let idContent = element.dataset.id;

                let content = $(`[data-content="${idContent}"]`);
                content.fadeToggle();
            });
        });
    }


    function scroll_to_top() {
        let link = document.querySelector('.scroll');

        if (link) {
            $(document).scroll(function () {
                if ($(document).scrollTop() >= 300) {
                    $(link).fadeIn();
                } else {
                    $(link).fadeOut();
                }
            });

            link.addEventListener('click', function (e) {
                e.preventDefault();

                $([document.documentElement, document.body]).animate({
                    scrollTop: $('body').offset().top - 50,
                }, 750);
            });
        }
    }

    function active_hamburger() {
        const $hamburger = $('.hamburger');
        const $headerMenu = $('.headerMenu-wrapper--mobile .headerMenu-container');
        const hamburgerActive = 'hamburger--active';
        const menuActive = 'headerMenu-container--active';

        $hamburger.click(function () {
            $(this).toggleClass(hamburgerActive);
            $headerMenu.toggleClass(menuActive);
        });

        $(window).click(function (event) {
            let target = $(event.target);
            let targetHamburger = target.hasClass('hamburger');

            if ($hamburger.hasClass(hamburgerActive) && !targetHamburger) {
                let menu = target.closest('.headerMenu-container');

                if (!menu.length) {
                    $hamburger.toggleClass(hamburgerActive);
                    $headerMenu.removeClass(menuActive);
                }
            }
        });
    }

    function generateSvg() {
        $('img.svg').ready(function () {
            $('img.svg').each(function () {

                let $img = $(this);
                let imgID = $img.attr('id');
                let imgClass = $img.attr('class');
                let imgURL = $img.attr('src');

                $.get(imgURL, function (data) {
                    let $svg = $(data).find('svg');

                    if (typeof imgID !== 'undefined') {
                        $svg = $svg.attr('id', imgID);
                    }

                    if (typeof imgClass !== 'undefined') {
                        $svg = $svg.attr('class', imgClass + ' replaced-svg');
                    }

                    $svg = $svg.removeAttr('xmlns:a');

                    if (!$svg.attr('viewBox') && $svg.attr('height') &&
                        $svg.attr('width')) {
                        $svg.attr('viewBox',
                            '0 0 ' + $svg.attr('height') + ' ' + $svg.attr('width'));
                    }

                    $img.replaceWith($svg);
                }, 'xml');
            });
        });

    }

    function switchContent($selector) {
        const switchContent = document.querySelector($selector);
        if (switchContent) {
            let tabs = switchContent.querySelectorAll('[data-tab]');
            let tabActive = ($selector + '__tab--active').split('.').join('');
            let contActive = ($selector + '__tabContent--active').split('.').join('');

            tabs.forEach((tab) =>
                tab.addEventListener('click', function (event) {
                    $('.' + tabActive).removeClass(tabActive);
                    $('.' + contActive).removeClass(contActive);

                    event.target.classList.add(tabActive);

                    let tabNumber = event.target.dataset.tab;
                    $(`[data-tab-content="${tabNumber}"]`).addClass(contActive);
                }),
            );
        }
    }


    function stickyHeader() {
        const body = $('body');
        const header = $('header');

        console.log(header.after(header.clone().addClass('header--sticky')));

        $(document).scroll(function () {
            if ($(document).scrollTop() >= 500) {

            } else {

            }
        });
    }
});